import { useTranslation } from 'react-i18next';
import { formatPriceOrDash, sumAvailablePrices } from '../../Utils/priceSimulationUtils';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import { InfoLabel } from '../Badges/InfoLabel';
import PackageStructureProductRow from './PackageStructureProductRow';
import { VossProductGroupType, VossProductGroupTypeText } from '../../Constants/VOSS/vossProductGroupType';
import type { DisplayProductGroup } from './PriceSimulation.types';

const PackageStructureGroupRow = ({ group }: { group: DisplayProductGroup }) => {
    const { t } = useTranslation();

    const totalPrice = sumAvailablePrices(group.products.map((product) => product.price));

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center py-8">
                <span className="d-flex align-items-center gap-8 font-weight-semibold">
                    <SpirisIcon name="purchasing" />
                    {group.name}
                    <InfoLabel
                        type={group.productGroupType === VossProductGroupType.Included ? 'success' : 'info'}
                        title={t(VossProductGroupTypeText[group.productGroupType] || 'vossProductGroupType.included')}
                    />
                </span>
                <span className="font-weight-semibold">{formatPriceOrDash(totalPrice)}</span>
            </div>
            {group.products.map((product) => (
                <PackageStructureProductRow key={product.id} product={product} />
            ))}
        </div>
    );
};

export default PackageStructureGroupRow;
